export const CLOSE_WEIGHT_DISPUTE_SUCCESS = "CLOSE_WEIGHT_DISPUTE_SUCCESS";
export const CLOSE_WEIGHT_DISPUTE_REQUEST = "CLOSE_WEIGHT_DISPUTE_REQUEST";
export const CLOSE_WEIGHT_DISPUTE_FAILURE = "CLOSE_WEIGHT_DISPUTE_FAILURE";
export const CLOSE_WEIGHT_DISPUTE_RESET = "CLOSE_WEIGHT_DISPUTE_RESET";
export const closeWeightDisputeSuccess = (payload) => ({
    type: CLOSE_WEIGHT_DISPUTE_SUCCESS,
    payload,
});
export const closeWeightDisputeRequest = (payload) => ({
    type: CLOSE_WEIGHT_DISPUTE_REQUEST,
    payload,
});
export const closeWeightDisputeFailure = (payload) => ({
    type: CLOSE_WEIGHT_DISPUTE_FAILURE,
    payload,
});
export const closeWeightDisputeReset = () => ({
    type: CLOSE_WEIGHT_DISPUTE_RESET,
});
